module.exports = __webpack_public_path__ + "static/media/animated_minee.3cca7edf.png";